import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCookieBite } from "@fortawesome/free-solid-svg-icons";
import { useTranslate } from "../locales/hooks";

interface ConsentBannerViewProps {
  onAccept: () => void;
  onDecline: () => void;
}

export default function ConsentBannerView({
  onAccept,
  onDecline,
}: ConsentBannerViewProps) {
  const t = useTranslate();

  return (
    <div className="fixed inset-x-0 bottom-0 z-[9998] flex justify-center px-3 pb-3">
      <div className="flex w-[min(96vw,720px)] flex-col gap-3 rounded-2xl border border-slate-200 bg-white/95 p-4 shadow-[0_8px_24px_rgba(15,23,42,0.16)] backdrop-blur sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <FontAwesomeIcon
            icon={faCookieBite}
            className="h-6 w-6 shrink-0 text-amber-600"
          />
          <p className="text-[13px] leading-5 text-slate-600">
            {t("consentBanner__text")}{" "}
            <Link
              to="/privacy"
              className="underline underline-offset-2 hover:text-slate-900"
            >
              {t("consentBanner__privacyLink")}
            </Link>
          </p>
        </div>
        <div className="flex shrink-0 justify-end gap-2">
          <button
            type="button"
            onClick={onDecline}
            className="rounded-xl border border-slate-300 px-4 py-2 text-sm hover:bg-slate-50"
          >
            {t("consentBanner__decline")}
          </button>
          <button
            type="button"
            onClick={onAccept}
            className="rounded-xl bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
          >
            {t("consentBanner__accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
